<template>
    <span class="youtube">
        <iframe :src="`https://www.youtube.com/embed/${id}`"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
        />
    </span>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
    name: 'VideoEmbedYouTube',
    props: {
        id: {
            type: String,
            required: true,
        },
    },
});
</script>
